// Wrap an Agent's steer method to fan out calls to subscribers as a
// side-effect of queuing. The original steer behavior is preserved —
// the message still lands in the loop's steer queue. Listeners are
// notified synchronously so long-running tools (e.g. spawn_subagent
// awaiting a child) can detect the user has steered and resolve
// early, surrendering control back to the agent loop so the steer
// drains at the next turn boundary.
//
// Why instrumentation instead of polling agent.hasQueuedMessages():
// polling adds latency (the steer is only noticed at the next tick)
// and forces a poll-interval choice that trades responsiveness vs
// CPU. A direct callback fires the moment the user pushes Send.
//
// pi-agent-core's raw Agent doesn't emit a "steer queued" event of
// its own; we shim the method on the instance so any caller (the
// existing ChatConsole steer button, future hotkeys, etc.) goes
// through us automatically.

export function instrumentSteer(agent) {
    const listeners = new Set();
    const original = agent.steer.bind(agent);
    agent.steer = (msg) => {
        const result = original(msg);
        for (const cb of listeners) {
            try { cb(msg); } catch { /* listener errors must not break steer */ }
        }
        return result;
    };
    return {
        subscribe(cb) {
            listeners.add(cb);
            return () => listeners.delete(cb);
        },
    };
}
